
const API={
    getcode:"/auth/code",//获取验证码
    login:"/auth/login",//登录
    logout:"/auth/logout",//登出
    usermenu:"/api/menus/build",//获取用户菜单权限
    users:"/api/users",//用户
    total:"/api/homePage/total",//查询首页统计数据
    total1:"/api/homePage/total1",//查询首页统计数据
    sevenDays:"/api/homePage/sevenDays",//查询首页七天数据
    summaryTotal:"/api/summaryTotal",//统计页上面统计
    order:"/api/order",//订单列表
    callorder:"/api/order/call",//催收订单列表
    mycallorder:"/api/order/mycall",//我的催收订单列表
    repayment:"/api/repayment",//还款列表
    rollover:"/api/rollover",//展期、逾期列表
    externalOrder:"/api/externalOrder",//外部订单
    userInfo:"/api/mcashuser/info",// 认证信息
    accountBook: "/api/accountBook", //账期
    classify: "/api/classify", //催收分类
    classifyAll: "/api/classify/all", //催收分类
    group: "/api/group", //催收小组
    telGroup: "/api/tel/group", //电销小组
    orderDetail: "/api/order/detail", //订单详情
    userContact: "/api/order/userContact", //订单用户的联系人
    callInfo: "/api/callInfo", //订单催收信息
    distributor: "/api/order/distributor", //分配订单
    contactInfo: "/api/mcashuser/contactInfo", //紧急联系人信息
    myOrderRecord:"/api/order/myOrderRecord",//我的订单记录
    sysNews:"/app/sysNews",//短信记录
    callTotal:"/api/homePage/callTotal",//查询首页统计数据
    callSuccTotal:"/api/order/callSuccTotal",//催收成功订单
    callDayTotal:"/api/homePage/callDayTotal",//查询今日催收统计数据
    callOldTotal:"/api/homePage/callOldTotal",//查询历史催收统计数据
    queryDayDetail:"/api/homePage/queryDayDetail",//查看每天详情
    groupAll: "/api/group/all", //催收小组
    telGroupAll: "/api/tel/group/all", //电销小组
    derate:"/api/derate", //催收减免
    callreport:"/api/call/data/callreport", //催收报表
    daycall:"/api/call/data/daycall", //每日数据总览
    queryCall:"/api/call/data/queryCall", //查询每日数据总览
    loan:"/api/call/data/loan",//贷后整体数据页面
    payError:"/api/order/payError",//放款失败订单
    lendingAgain:"/api/order/lendingAgain",//重新放款
    channelAn:"/api/bazaar/channelAn",//投放渠道分析
    complexPower:"/api/bazaar/complexPower",//复借率统计
    getUserTime:"/api/mcashuser/getUserTime",//获取多少时间没有新增用户
    calldateil:"/api/call/data/calldateil",//在催历史统计详情
    monitorData:"/api/risk/monitor/data",//风控数据监控
    calluser:"/api/call/data/user",//催收员工
    callSuccyqTotal:"/api/order/callSuccyqTotal",//催收成功逾期订单
    sevenEsDays:"/api/homePage/sevenEsDays",//查询预估七天数据
    cancelarOrder:"/api/order/cancelar",//结清订单
    orderMoneyTax:"/api/order/moneyTax",//订单金额减免
    pushinfo:"/api/push/info",//消息推送
    categor:"/api/categor",//等級
    plantilla:"/api/plantilla",//消息模板
    mcashuser:"/api/mcashuser",//mcash用户
    check:"/api/check",//信息审核
    cardcheck:"/api/check/card",//身份证审核
    checkorder:"/api/check/order",//审核订单
    loanPay:"/api/check/orderPay",//订单放款
    myUserAuth:"/api/mcashuser/myUserAuth",//自己的审核用户
    addBlacklist:"/api/mcashuser/addBlacklist",//添加黑名单
    dial:"/api/mcashuser/dial",//语音拨打
    walky:"/api/walky",//话机拨打记录
    agingInfo:"/api/order/aging/info",//分期信息
    saveAgingOrder:"/api/order/saveAgingOrder",//保存分期订单
    agingCheck:"/api/order/agingCheck",//分期订单生效
    proofquery:"/api/order/proofquery",//订单放款凭证查询
    relevanceOrder:"/api/order/relevanceOrder",//关联订单
    profitStatistics:"/api/order/profit/statistics",//利润报表
    associatedTel:"/api/order/associated/tel",//关联电话
    labour:"api/plantilla/labour", //人工推送
    superfluous:"/api/repayment/superfluous",//还款列表
    telList:"/api/tel/list",//电销列表
    telWorkTotal:"/api/tel/workTotal",//电销工作量统计
    telPer:"/api/tel/per",//电销代理绩效报告-旧的
    telPerNew:"/api/tel/perNew",//电销代理绩效报告-新的
    waDial:"/api/mcashuser/wa/dial",//wa拨打
    telinfo:"/api/tel/info",//电销跟踪记录
    allconfig: "/api/allConfig", //分配配置
    allocation: "/api/allConfig/allocation", //分配执行


    telTotal:"/api/tel/telTotal",//查询电销首页统计数据
    mytelorder:"/api/tel/mytelorder",//我的催收电销列表
    succTelList:"/api/tel/succlist",//成功电销列表
    teldistributor: "/api/tel/distributor", //分配号码

    exportWorkDate:"/api/tel/workTotal/download",//导出电销工作量统计数据
    exportPerDate:"/api/tel/per/download",//导出绩效报告数据-旧的
    exportPerNewDate:"/api/tel/perNew/download",//导出绩效报告数据-新的
    exportCallOldTotal:"/api/homePage/callOldTotal/download",//导出再催历史统计数据


    registerPay:"/api/report/registerPay",//注册交易报表
    loaninfo:"/api/report/loaninfo",//放款报表
    dueDate:"/api/report/dueDate",//到期日报表
    relending:"/api/report/relending",//复贷报表
    profit:"/api/report/profit",//利润报表
    telGroup1: "/api/tel/group/all", //电销小组

    loanBalanceDay:"/api/report/loan/balance/day",//在贷余额报表-每日
    loanBalanceMoon:"/api/report/loan/balance/moon",//在贷余额报表-每月

    typeList: "/api/tel/typeList", //电销类型

    userInfoQuery: "/api/tel/query/userInfo", //用户信息查询
    numDetail: "/api/tel/query/numDetail", //用户信息查询

    activityLevel: "/api/tel/activity/level", //用户活跃度
    exportActivityLevel: "/api/tel/activity/level/download", //导出用户活跃度
    exportActiveUsers: "/api/tel/activity/users/download", //导出活跃用户
    pushtotal:"/api/report/pushtotal",//push报表

    productnew: "/api/productnew", //产品信息配置
    productnewAll: "/api/productnew/all", //产品信息配置
    productnewAll1: "/api/productnew/all1", //产品信息配置
    creditConfig: "/api/credit/config", //授信配置
    creditModel: "/api/credit/config/queryModel", //授信模型
    policy: "/api/policy/config", //提额策略配置

    userAuthAudit:"/api/mcashuser/userAuthAudit",// 审核认证信息

    groupbusy:"/api/call/result/list",//群呼列表
    groupbusySuccess:"/api/call/result/list/success",//群呼成功列表


}

export default API